// use this when we want to submit the form on document load
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // The partial is action-cached, so we can't gate the form server-side.
    // Instead, check an uncached meta tag set in the layout to decide whether
    // the current user has permission before firing the POST.
    const allowed = document.querySelector('meta[name="permission-archetype-edit"]');
    if (!allowed) {
      this.element.remove();
      return;
    }

    try { refreshCSRFTokens(); } catch (e) { /* CSRF meta tag may be absent */ }

    this.element.addEventListener('turbo:fetch-request-error', (event) => {
      event.preventDefault();
      console.warn('[form-auto-submit-onload] fetch failed, skipping');
    });

    if (typeof this.element.requestSubmit === 'function') {
      this.element.requestSubmit();
    } else {
      // requestSubmit() not available (Safari < 15.4): dispatch the submit event so
      // Turbo can intercept it, rather than calling submit() which bypasses Turbo.
      this.element.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }
}
